import React from 'react';

export const condenseHeader = (title: string) => {
  let titleArr = title.split(' ');
  switch (titleArr.length) {
    case 1: {
      return titleArr[0];
    }
    case 2: {
      return (
        <div>
          {titleArr[0]}
          <br />
          {titleArr[1]}
        </div>
      );
    }

    case 3: {
      return (
        <div>
          {titleArr[0]}
          <br />
          {titleArr[1] + ' ' + titleArr[2]}
        </div>
      );
    }
    case 4: {
      return (
        <div>
          {titleArr[0] + ' ' + titleArr[1]}
          <br />
          {titleArr[2] + ' ' + titleArr[3]}
        </div>
      );
    }
  }
};

export const openDepartment = ({ value, row }: any) => {
  if (value != null) {
    return (
      <a href={`/Admin/deviceRefreshReport/${row.deptId}/false`} className='info'>
        {row.deptName}
      </a>
    );
  }
  return '';
};

export const openDepartment6yrs = ({ value, row }: any) => {
  if (value != null) {
    return (
      <a href={`/Admin/deviceRefreshReport/${row.deptId}/true`} className='info'>
        {row.deptName}
      </a>
    );
  }
  return '';
};

const boolCheck = ({ value, row }: any) => {
  if (value != null) {
    if (row.needRefresh)
      return (
        <div className='justify-content-md-center'>
          <i className='fa fa-check' />
        </div>
      );
  }
  return '';
};

const convertTime = ({ value, row }: any) => {
  if (value != null) {
    const totalDays = row.yrsOld * 365;
    const years = Math.floor(totalDays / 365);
    const months = Math.floor((totalDays - years * 365) / 30);
    if (months === 0) {
      return years + ' years';
    } else if (years === 0) {
      return months + ' months';
    } else return years + ' years, ' + months + ' months';
  }
  return row.yrsOld;
};

export const perDeptColumns = [
  {
    Header: condenseHeader('Barcode'),
    accessor: 'barCode',
  },
  {
    Header: condenseHeader('Asset Number'),
    accessor: 'assetNumber',
  },
  {
    Header: 'Description 1',
    accessor: 'description1',
  },
  {
    Header: 'Description 2',
    accessor: 'description2',
  },
  {
    Header: 'Description 3',
    accessor: 'description3',
  },
  {
    Header: condenseHeader('Device Age (Years)'),
    accessor: 'yrsOld',
    Cell: convertTime,
  },
  {
    Header: condenseHeader('Needs Refresh?'),
    accessor: 'needRefresh',
    width: 70,
    Cell: boolCheck,
  },
];

// export const totalColumns = [
//   {
//     column: {
//       Header: condenseHeader('Department Name'),
//       accessor: 'deptName',
//       // width: 220,
//       minWidth: 220,
//       resizable: true,
//       Cell: openDepartment,
//     },
//     type: 'string',
//   },
//   {
//     column: {
//       Header: condenseHeader('# Desktops To Refresh'),
//       accessor: 'numDesktopsToRefresh',
//       minWidth: 85,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Total Desktops'),
//       accessor: 'totalDesktops',
//       minWidth: 90,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('# Laptops To Refresh'),
//       accessor: 'numLaptopsToRefresh',
//       minWidth: 90,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Total Laptops'),
//       accessor: 'totalLaptops',
//       minWidth: 80,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('# iPads to Refresh'),
//       accessor: 'numIpadsToRefresh',
//       minWidth: 90,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Total iPads'),
//       accessor: 'totalIpads',
//       minWidth: 60,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('# Tablets To Refresh'),
//       accessor: 'numTabletsToRefresh',
//       minWidth: 90,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Total Tablets'),
//       accessor: 'totalTablets',
//       minWidth: 70,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('# Devices To Refresh'),
//       accessor: 'numDevicesToRefresh',
//       minWidth: 90,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Total Devices'),
//       accessor: 'totalDevices',
//       minWidth: 70,
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       Header: condenseHeader('Average Device Age (Years)'),
//       accessor: 'avgYrsOld',
//       resizable: true,
//     },
//     type: 'number',
//   },
//   {
//     column: {
//       accessor: 'deptId',
//       show: false,
//     },
//     type: 'number',
//   },
// ];
